import { Layout } from 'antd';
import Top from './Header';
import PageContainer from '../components/PageContainer';

import FooterContent from './Footer';
import {Banner} from "../views/Home/components/Banner";

const { Header, Content, Footer } = Layout;

const LayoutComponent = ({ children }) => {
  return (
    <Layout>
      <Header
        style={{ position: 'sticky', top: 0, zIndex: 2, maxWidth: '100%' }}
      >
        <Top />
      </Header>
        {/*<Banner />*/}
        <Content>
        <PageContainer>{children}</PageContainer>
      </Content>
      <Footer>
        <FooterContent />
      </Footer>
    </Layout>
  );
};

export default LayoutComponent;
